import(/* webpackMode: "eager" */ "/codebuild/output/src828441159/src/client/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src828441159/src/client/src/app/(public)/[sport]/injuries/filter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src828441159/src/client/src/components/primitives/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src828441159/src/client/src/components/primitives/icon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src828441159/src/client/src/components/team/injuries-table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src828441159/src/client/src/components/team/logo.tsx");
